import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { useFormikContext } from 'formik'
import { useCallback } from 'react'
import { createSystemOpportunityName } from '../functions'

type Props = {
  services: ILeadOppProduct[]
  customName: string | undefined
}

export function useHandlers<T>(props: Props) {
  const { services, customName } = props

  const { setFieldValue } = useFormikContext<T>()

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const useSystemName = event.target.value
      if (useSystemName === 'true') {
        setFieldValue('opportunityName', createSystemOpportunityName(services))
      } else {
        if (useSystemName === 'false' && customName)
          setFieldValue('opportunityName', customName)
      }
    },
    [services, setFieldValue, customName],
  )

  return { onChange } as const
}
